import * as React from 'react';

import useUrlState from '@ahooksjs/use-url-state';
import { useGetState, useMemoizedFn, useRequest } from 'ahooks';
import { Helmet } from 'react-helmet-async';

import { searchShippingConfigs } from 'services';
import { PATHNAME } from 'utils';

import { ShippingConfigsHeader, ShippingConfigsTable } from './components';

const {
  QUERY_PARAM: {
    DEFAULT: {
      SORT_TYPE: DEFAULT_SORT_TYPE,
      PAGE_NUMBER: DEFAULT_PAGE_NUMBER,
      PAGE_SIZE: DEFAULT_PAGE_SIZE,
    },
    SORT_TYPE: { BASE_URL: SORT_TYPE_BASE_URL },
    SEARCH_KEY: { BASE_URL: SEARCH_KEY_BASE_URL },
    PAGE_NUMBER: { BASE_URL: PAGE_NUMBER_BASE_URL },
  },
} = PATHNAME;

export default function ShippingConfigs() {
  const [
    {
      [SORT_TYPE_BASE_URL]: sortType,
      [SEARCH_KEY_BASE_URL]: searchKey,
      [PAGE_NUMBER_BASE_URL]: pageNumber,
    },
    setUrlState,
  ] = useUrlState(
    {
      [SORT_TYPE_BASE_URL]: DEFAULT_SORT_TYPE,
      [SEARCH_KEY_BASE_URL]: '',
      [PAGE_NUMBER_BASE_URL]: DEFAULT_PAGE_NUMBER,
    },
    { navigateMode: 'replace' },
  );
  const [pageSize, setPageSize] = useGetState<number>(DEFAULT_PAGE_SIZE);
  const { data, loading, refresh } = useRequest(
    async () =>
      await searchShippingConfigs({
        sortType,
        searchKey,
        pageNumber,
        pageSize,
      }),
    {
      refreshDeps: [sortType, searchKey, pageNumber, pageSize],
    },
  );

  const { total = 0, data: shippingConfigs = [] } = data ?? {};

  const handleSearchKey = useMemoizedFn((updatedSearchKey: string) => {
    setUrlState({ [SEARCH_KEY_BASE_URL]: updatedSearchKey });
  });
  const handlePageNumber = useMemoizedFn((updatedPageNumber: number) => {
    setUrlState({ [PAGE_NUMBER_BASE_URL]: updatedPageNumber });
  });
  const handlePageSize = useMemoizedFn((updatedPageSize: number) => {
    setPageSize(updatedPageSize);
  });

  return (
    <React.Fragment>
      <Helmet>
        <title>تنظیمات ارسال | کاشی لند</title>
      </Helmet>
      <div className='rounded bg-white p-6'>
        <ShippingConfigsHeader
          searchKey={searchKey}
          handleSearchKey={handleSearchKey}
        />
        <ShippingConfigsTable
          loading={loading}
          total={total}
          shippingConfigs={shippingConfigs}
          pageSize={pageSize}
          pageNumber={pageNumber}
          handlePageSize={handlePageSize}
          handlePageNumber={handlePageNumber}
          handleRefreshData={refresh}
        />
      </div>
    </React.Fragment>
  );
}
